import { fmtPrice } from "@/lib/format";
import { cn } from "@/lib/utils";

export const PriceTable = ({ lines = [], note, className, testId = "price-table" }) => {
  if (!lines.length) {
    return (
      <p className="py-4 text-[15px] text-muted-foreground" data-testid={`${testId}-empty`}>
        {note || "Pris etter avtale – ta kontakt."}
      </p>
    );
  }
  return (
    <div className={cn(className)} data-testid={testId}>
      {lines.map((l, i) => {
        const meta = [l.unit && l.unit !== "Stengt" ? l.unit : null, l.includes_cleaning ? "inkl. vask" : null].filter(Boolean).join(" · ");
        return (
          <div key={i} className="grid grid-cols-[1fr_auto] items-baseline gap-4 rule-b py-3.5 last:border-b-0">
            <div>
              <div className="text-[15px] leading-snug">{l.label}</div>
              {meta && <div className="t-mono mt-1 text-muted-foreground">{meta}</div>}
            </div>
            <div className="tabular text-[15px] tabular">
              {l.price === null || l.price === undefined ? <span className="t-mono text-amber-800">{l.unit || "Stengt"}</span> : fmtPrice(l.price)}
            </div>
          </div>
        );
      })}
      {note && <p className="rule py-3 text-xs leading-relaxed text-muted-foreground">{note}</p>}
    </div>
  );
};
